module.exports = __webpack_public_path__ + "static/media/galleryImg10.e05a2428.jpg";